export default __webpack_public_path__ + "static/media/choco_chip_pan.c984d75c.jpg";